import { render, staticRenderFns } from "./poUserChip.vue?vue&type=template&id=167835ae"
import script from "./poUserChip.vue?vue&type=script&lang=js"
export * from "./poUserChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports